// extracted by mini-css-extract-plugin
module.exports = {"floatAd":"_8849","image":"_10825"};